export default "__VITE_ASSET__DeZ0otJi__"